// extracted by mini-css-extract-plugin
module.exports = {"capture":"Capture_capture__Lh_Yb"};